export const agwCapabilities = {
    '0xab5': {
        atomicBatch: {
            supported: true,
        },
    },
    '0x2b74': {
        atomicBatch: {
            supported: true,
        },
    },
};
//# sourceMappingURL=eip5792.js.map